/* Nova theme — vanilla JS, no dependencies */
(() => {
  const T = window.theme || {};
  T.strings = T.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const rootUrl = ((T.routes && T.routes.root) || '/').replace(/\/?$/, '/');
  const designMode = !!(window.Shopify && window.Shopify.designMode);

  const esc = (str) => String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  let moneyFormatter;
  const fmt = (cents) => {
    try {
      moneyFormatter = moneyFormatter || new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency || 'USD' });
      return moneyFormatter.format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  };
  T.formatMoney = fmt;

  /* ---------------- Toast ---------------- */
  let toastTimer;
  const toast = (msg) => {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 3500);
  };

  /* ---------------- Drawers / modals ---------------- */
  const anyOpen = () => $$('[data-closable].is-open').length > 0;
  const openPanel = (el) => {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
  };
  const closePanel = (el) => {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!anyOpen()) document.documentElement.classList.remove('is-locked');
  };
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('[data-closable].is-open').forEach(closePanel);
  });

  /* ---------------- Cart ---------------- */
  const Cart = {
    drawer: () => $('[data-cart-drawer]'),
    open() {
      if (T.cartType === 'page') {
        window.location.href = T.routes.cart;
        return;
      }
      openPanel(this.drawer());
    },
    render(sections) {
      if (!sections || !sections['cart-drawer']) return this.refresh();
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = $('[data-cart-drawer-inner]', doc);
      const current = $('[data-cart-drawer-inner]');
      if (fresh && current) current.replaceWith(fresh);
      if (fresh) {
        const count = fresh.dataset.count || '0';
        $$('[data-cart-count]').forEach((el) => {
          el.textContent = count;
          el.classList.toggle('is-empty', count === '0');
        });
      }
      initShipBars(document);
    },
    async refresh() {
      const res = await fetch(`${rootUrl}?sections=cart-drawer`);
      const json = await res.json();
      if (json && json['cart-drawer']) this.render(json);
    },
    async add(items) {
      const res = await fetch(`${T.routes.cart_add}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      if (T.cartType === 'page') {
        window.location.href = T.routes.cart;
        return data;
      }
      this.render(data.sections);
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
      this.open();
      return data;
    },
    async change(line, quantity) {
      const res = await fetch(`${T.routes.cart_change}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      this.render(data.sections);
      return data;
    }
  };
  T.cart = Cart;

  /* Free shipping progress bar (threshold converted to the active currency) */
  function initShipBars(scope) {
    const rate = (window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate)) || 1;
    $$('[data-ship-bar]', scope).forEach((bar) => {
      const threshold = Math.round(parseFloat(bar.dataset.threshold) * rate);
      const total = parseInt(bar.dataset.total, 10) || 0;
      const left = Math.max(0, threshold - total);
      const pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
      const fill = $('[data-ship-fill]', bar);
      if (fill) requestAnimationFrame(() => (fill.style.width = `${pct}%`));
      const text = $('[data-ship-text]', bar);
      if (text) {
        text.innerHTML = left > 0
          ? esc(bar.dataset.away).replace('[amount]', `<strong>${fmt(left)}</strong>`)
          : `🎉 ${esc(bar.dataset.done)}`;
      }
      bar.classList.toggle('is-done', left <= 0);
    });
  }

  /* ---------------- Global click handling ---------------- */
  document.addEventListener('click', (e) => {
    const t = e.target;

    if (t.closest('[data-cart-open]')) {
      if (T.cartType !== 'page' && T.template !== 'cart') {
        e.preventDefault();
        Cart.open();
      }
      return;
    }

    if (t.closest('[data-drawer-close]')) {
      e.preventDefault();
      closePanel(t.closest('[data-closable]'));
      return;
    }

    if (t.closest('[data-menu-open]')) {
      e.preventDefault();
      openPanel($('[data-menu-drawer]'));
      return;
    }

    const searchOpen = t.closest('[data-search-open]');
    if (searchOpen) {
      const modal = $('[data-search-modal]');
      if (!modal) return;
      e.preventDefault();
      openPanel(modal);
      setTimeout(() => { const i = $('input[name="q"]', modal); i && i.focus(); }, 80);
      return;
    }

    const lineBtn = t.closest('[data-line-qty]');
    if (lineBtn) {
      e.preventDefault();
      const item = lineBtn.closest('.line-item');
      item && item.classList.add('is-loading');
      Cart.change(parseInt(lineBtn.dataset.line, 10), parseInt(lineBtn.dataset.lineQty, 10))
        .catch((err) => { toast(err.message); item && item.classList.remove('is-loading'); });
      return;
    }

    const quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      Cart.add([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }])
        .catch((err) => toast(err.message))
        .finally(() => quick.classList.remove('is-loading'));
      return;
    }

    const sliderBtn = t.closest('[data-slider-prev], [data-slider-next]');
    if (sliderBtn) {
      const slider = sliderBtn.closest('[data-slider]');
      const track = slider && $('[data-slider-track]', slider);
      if (!track) return;
      const first = track.firstElementChild;
      const step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      const dir = sliderBtn.hasAttribute('data-slider-next') ? 1 : -1;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dir === 1 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: dir * step, behavior: 'smooth' });
      return;
    }

    const sound = t.closest('[data-reel-sound]');
    if (sound) {
      const reel = sound.closest('[data-reel]');
      const video = reel && $('video', reel);
      if (!video) return;
      $$('[data-reel] video').forEach((v) => { if (v !== video) { v.muted = true; v.closest('[data-reel]').classList.remove('is-unmuted'); } });
      video.muted = !video.muted;
      if (!video.muted) video.play();
      reel.classList.toggle('is-unmuted', !video.muted);
    }
  });

  /* Auto-submit selects (localization, sort, filters) */
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el.matches('[data-autosubmit]') || (el.closest('[data-filter-form]') && el.type === 'checkbox')) {
      const form = el.form || el.closest('form');
      if (form) form.submit();
    }
  });

  /* ---------------- Predictive search ---------------- */
  let searchTimer;
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-search-input]');
    if (!input) return;
    const out = $('[data-search-results]');
    if (!out) return;
    clearTimeout(searchTimer);
    const q = input.value.trim();
    if (!q) { out.innerHTML = ''; return; }
    searchTimer = setTimeout(async () => {
      try {
        const res = await fetch(`${rootUrl}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const json = await res.json();
        const items = (json.resources && json.resources.results && json.resources.results.products) || [];
        out.innerHTML = items.length
          ? items.map((p) => `
              <a class="sr-item" href="${esc(p.url)}">
                ${p.image ? `<img src="${esc(p.image)}" alt="" width="56" height="56" loading="lazy">` : '<span class="sr-item__ph"></span>'}
                <span><span class="sr-item__title">${esc(p.title)}</span><span class="sr-item__price">${fmt(Math.round(parseFloat(p.price) * 100))}</span></span>
              </a>`).join('')
          : `<p class="sr-empty">${esc(T.strings.noResults || '')}</p>`;
      } catch (err) { /* ignore */ }
    }, 220);
  });

  /* ---------------- Header scroll state ---------------- */
  const onScroll = () => {
    const header = $('[data-header]');
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------------- Announcement bar ---------------- */
  function initAnnouncements(scope) {
    $$('[data-announcement]', scope).forEach((bar) => {
      if (bar._timer) clearInterval(bar._timer);
      const slides = $$('[data-announcement-slide]', bar);
      if (slides.length < 2) return;
      let i = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
      const show = (n) => {
        slides[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
      };
      const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      const start = () => { clearInterval(bar._timer); bar._timer = setInterval(() => show(i + 1), speed); };
      const prev = $('[data-ann-prev]', bar);
      const next = $('[data-ann-next]', bar);
      prev && (prev.onclick = () => { show(i - 1); start(); });
      next && (next.onclick = () => { show(i + 1); start(); });
      start();
    });
  }

  /* ---------------- Countdown ---------------- */
  function initCountdowns(scope) {
    $$('[data-countdown]', scope).forEach((el) => {
      if (el._cd) clearInterval(el._cd);
      const end = Date.parse(String(el.dataset.countdown).trim().replace(' ', 'T'));
      if (isNaN(end)) return;
      const pad = (n) => String(n).padStart(2, '0');
      const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = pad(v); };
      const tick = () => {
        const diff = Math.max(0, end - Date.now());
        set('[data-d]', Math.floor(diff / 864e5));
        set('[data-h]', Math.floor((diff % 864e5) / 36e5));
        set('[data-m]', Math.floor((diff % 36e5) / 6e4));
        set('[data-s]', Math.floor((diff % 6e4) / 1e3));
        if (diff <= 0) {
          clearInterval(el._cd);
          el.classList.add('is-ended');
          if (el.hasAttribute('data-hide-ended') && !designMode) el.hidden = true;
        }
      };
      tick();
      el._cd = setInterval(tick, 1000);
    });
  }

  /* ---------------- Delivery estimate ---------------- */
  function initDelivery(scope) {
    $$('[data-delivery]', scope).forEach((el) => {
      const skip = el.dataset.skip === 'true';
      const addDays = (n) => {
        const d = new Date();
        let added = 0;
        while (added < n) {
          d.setDate(d.getDate() + 1);
          if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
        }
        return d;
      };
      const f = (d) => d.toLocaleDateString(T.locale || undefined, { month: 'short', day: 'numeric' });
      const ship = addDays(parseInt(el.dataset.ship, 10) || 0);
      const min = addDays(parseInt(el.dataset.min, 10) || 1);
      const max = addDays(parseInt(el.dataset.max, 10) || 1);
      const set = (sel, v) => { const n = $(sel, el); if (n) n.textContent = v; };
      set('[data-date-order]', f(new Date()));
      set('[data-date-ship]', f(ship));
      set('[data-date-deliver]', `${f(min)} – ${f(max)}`);
      const head = $('[data-delivery-heading]', el);
      if (head) {
        const longDate = max.toLocaleDateString(T.locale || undefined, { weekday: 'long', month: 'long', day: 'numeric' });
        head.innerHTML = esc(head.dataset.template).replace('[date]', `<strong>${esc(longDate)}</strong>`);
      }
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  let revealObserver;
  function initReveal(scope) {
    const items = $$('.reveal:not(.is-in)', scope);
    if (!document.body.classList.contains('has-anim') || designMode || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    revealObserver = revealObserver || new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          revealObserver.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((el) => revealObserver.observe(el));
  }

  /* ---------------- Count-up numbers ---------------- */
  function initCounters(scope) {
    const els = $$('[data-count]', scope);
    if (!els.length) return;
    const run = (el) => {
      const raw = String(el.dataset.count).replace(/[^0-9.]/g, '');
      const target = parseFloat(raw);
      if (isNaN(target)) return;
      const decimals = (raw.split('.')[1] || '').length;
      const start = performance.now();
      const dur = 1400;
      const step = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toLocaleString(T.locale || undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (designMode || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- Product recommendations ---------------- */
  function initRecommendations(scope) {
    $$('[data-recommendations]', scope).forEach(async (el) => {
      if (el.dataset.loaded || !el.dataset.url) return;
      el.dataset.loaded = '1';
      try {
        const res = await fetch(el.dataset.url);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
        }
      } catch (err) { /* ignore */ }
    });
  }

  /* ---------------- Product page ---------------- */
  class Product {
    constructor(el) {
      this.el = el;
      const json = $('[data-product-json]', el);
      if (!json) return;
      this.data = JSON.parse(json.textContent);
      this.variants = this.data.variants || [];
      this.form = $('[data-main-form]', el);
      this.idInput = $('[data-variant-id]', el);
      const initialId = this.idInput ? parseInt(this.idInput.value, 10) : null;
      this.variant = this.variants.find((v) => v.id === initialId) || this.variants.find((v) => v.available) || this.variants[0];
      this.bundle = $('[data-bundle]', el);
      this.qty = $('[data-qty-input]', el);
      this.showPriceInBtn = el.dataset.btnPrice === 'true';
      this.unitValues = [];

      this.bindGallery();
      this.bindPicker();
      this.bindBundle();
      this.bindQty();
      this.bindUpsells();
      this.bindForm();
      this.bindSticky();
      this.update();
    }

    find(id) { return this.variants.find((v) => v.id === parseInt(id, 10)); }

    /* Gallery */
    bindGallery() {
      const g = $('[data-gallery]', this.el);
      if (!g) return;
      const track = $('[data-gallery-track]', g);
      const slides = $$('.gallery__slide', track);
      const thumbs = $$('[data-thumb]', g);
      const thumbsWrap = $('[data-gallery-thumbs]', g);
      const dots = $$('[data-dot]', g);
      let current = 0;
      const setActive = (i) => {
        current = i;
        thumbs.forEach((t, j) => t.classList.toggle('is-active', i === j));
        dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
        const th = thumbs[i];
        if (th && thumbsWrap) {
          thumbsWrap.scrollTo({ left: th.offsetLeft - thumbsWrap.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
        }
      };
      this.goTo = (i, smooth = true) => {
        if (!slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
        setActive(i);
      };
      this.goToMedia = (mediaId) => {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i >= 0) this.goTo(i);
      };
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i);
        });
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));
      const prev = $('[data-gallery-prev]', g);
      const next = $('[data-gallery-next]', g);
      prev && prev.addEventListener('click', () => this.goTo(current > 0 ? current - 1 : slides.length - 1));
      next && next.addEventListener('click', () => this.goTo(current < slides.length - 1 ? current + 1 : 0));

      const initial = $('[data-initial-media]', this.el);
      if (initial) {
        const i = slides.findIndex((s) => s.dataset.mediaId === initial.dataset.initialMedia);
        if (i > 0) requestAnimationFrame(() => this.goTo(i, false));
      }
    }

    /* Variant picker (buttons / dropdowns) */
    bindPicker() {
      const picker = $('[data-variant-picker]', this.el);
      if (!picker) return;
      this.picker = picker;
      picker.addEventListener('change', () => {
        const groups = $$('[data-option-index]', picker);
        const opts = groups.map((group) => {
          const checked = $('input:checked', group);
          const select = $('select', group);
          const value = checked ? checked.value : select ? select.value : null;
          const label = $('[data-selected-value]', group);
          if (label) label.textContent = value;
          return value;
        });
        const match = this.variants.find((v) => v.options.every((o, i) => o === opts[i]));
        if (match) {
          this.setVariant(match, true);
        } else {
          this.variant = Object.assign({}, this.variant, { available: false });
          this.update();
        }
      });
    }

    setVariant(v, fromPicker) {
      this.variant = v;
      if (this.bundle && fromPicker) {
        this.unitValues = this.unitValues.map(() => v.id);
        const tier = this.selectedTier();
        if (tier) this.renderUnits(tier);
      }
      if (v.media_id && this.goToMedia) this.goToMedia(v.media_id);
      if (this.el.dataset.updateUrl === 'true' && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      this.update();
    }

    /* Quantity offers */
    selectedTier() {
      if (!this.bundle) return null;
      return $('[data-tier].is-selected', this.bundle) || $('[data-tier]', this.bundle);
    }

    bindBundle() {
      if (!this.bundle) return;
      this.bundle.addEventListener('change', (e) => {
        const radio = e.target.closest('[data-tier-radio]');
        if (radio) {
          const tier = radio.closest('[data-tier]');
          if (!tier.classList.contains('is-selected')) this.selectTier(tier);
          return;
        }
        const sel = e.target.closest('[data-unit-select]');
        if (sel) {
          this.unitValues = $$('[data-unit-select]', this.bundle).map((s) => parseInt(s.value, 10));
          const v = this.find(sel.value);
          const img = $('img.unit__img', sel.closest('.unit'));
          if (img && v && v.image) img.src = v.image;
          if (v && v.media_id && this.goToMedia) this.goToMedia(v.media_id);
          this.update();
        }
      });
      this.bundle.addEventListener('click', (e) => {
        if (e.target.closest('[data-units]') || e.target.closest('label')) return;
        const tier = e.target.closest('[data-tier]');
        if (tier && !tier.classList.contains('is-selected')) this.selectTier(tier);
      });
      const tier = this.selectedTier();
      if (tier) this.selectTier(tier);
    }

    selectTier(tier) {
      $$('[data-tier]', this.bundle).forEach((t) => {
        const on = t === tier;
        t.classList.toggle('is-selected', on);
        const r = $('[data-tier-radio]', t);
        if (r) r.checked = on;
      });
      this.renderUnits(tier);
      this.update();
    }

    renderUnits(tier) {
      $$('[data-units]', this.bundle).forEach((box) => { if (box.closest('[data-tier]') !== tier) box.innerHTML = ''; });
      const box = $('[data-units]', tier);
      if (!box) return;
      if (this.variants.length < 2) { box.innerHTML = ''; return; }
      const qty = parseInt(tier.dataset.qty, 10) || 1;
      const label = this.bundle.dataset.unitLabel || '';
      const chevron = '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      let html = '';
      for (let i = 0; i < qty; i++) {
        const v = this.find(this.unitValues[i]) || this.variant;
        const options = this.variants.map((o) =>
          `<option value="${o.id}"${o.id === v.id ? ' selected' : ''}${o.available ? '' : ' disabled'}>${esc(o.title)}${o.available ? '' : ` — ${esc(T.strings.soldOut || '')}`}</option>`
        ).join('');
        html += `
          <div class="unit">
            <span class="unit__label">${esc(label)} ${i + 1}</span>
            ${v.image ? `<img class="unit__img" src="${esc(v.image)}" alt="" width="44" height="44" loading="lazy">` : '<span class="unit__img"></span>'}
            <div class="select"><select data-unit-select aria-label="${esc(label)} ${i + 1}">${options}</select>${chevron}</div>
          </div>`;
      }
      box.innerHTML = html;
      this.unitValues = $$('[data-unit-select]', box).map((s) => parseInt(s.value, 10));
    }

    /* Plain quantity selector */
    bindQty() {
      if (!this.qty) return;
      const wrap = this.qty.closest('.qty');
      const minus = $('[data-qty-minus]', wrap);
      const plus = $('[data-qty-plus]', wrap);
      const set = (n) => { this.qty.value = Math.max(1, n); this.update(); };
      minus && minus.addEventListener('click', () => set((parseInt(this.qty.value, 10) || 1) - 1));
      plus && plus.addEventListener('click', () => set((parseInt(this.qty.value, 10) || 1) + 1));
      this.qty.addEventListener('change', () => set(parseInt(this.qty.value, 10) || 1));
    }

    bindUpsells() {
      $$('[data-upsell]', this.el).forEach((u) => {
        const cb = $('[data-upsell-check]', u);
        cb && cb.addEventListener('change', () => { u.classList.toggle('is-checked', cb.checked); this.update(); });
      });
    }

    units() {
      const tier = this.selectedTier();
      if (!tier) {
        const q = this.qty ? Math.max(1, parseInt(this.qty.value, 10) || 1) : 1;
        return Array(q).fill(this.variant);
      }
      const qty = parseInt(tier.dataset.qty, 10) || 1;
      const selects = $$('[data-unit-select]', tier);
      if (!selects.length) return Array(qty).fill(this.variant);
      return selects.map((s) => this.find(s.value) || this.variant);
    }

    totals() {
      const units = this.units();
      const tier = this.selectedTier();
      const disc = tier ? parseFloat(tier.dataset.discount) || 0 : 0;
      const base = units.reduce((a, v) => a + v.price, 0);
      const total = Math.round((base * (100 - disc)) / 100);
      let upsell = 0;
      $$('[data-upsell]', this.el).forEach((u) => {
        const cb = $('[data-upsell-check]', u);
        if (cb && cb.checked) upsell += parseInt(u.dataset.upsellPrice, 10) || 0;
      });
      return { units, total, grand: total + upsell, available: units.every((v) => v && v.available) };
    }

    update() {
      const v = this.variant;
      if (!v) return;
      const t = this.totals();

      /* Unit price block */
      const onSale = v.compare_at_price > v.price;
      $$('[data-price]', this.el).forEach((n) => { n.textContent = fmt(v.price); n.classList.toggle('is-sale', onSale); });
      $$('[data-compare]', this.el).forEach((n) => { n.textContent = onSale ? fmt(v.compare_at_price) : ''; n.hidden = !onSale; });
      $$('[data-save]', this.el).forEach((n) => {
        if (onSale) {
          const pct = Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
          n.textContent = n.dataset.mode === 'amount' ? `${n.dataset.label} ${fmt(v.compare_at_price - v.price)}` : `${n.dataset.label} ${pct}%`;
        }
        n.hidden = !onSale;
      });

      /* Offer tiers */
      if (this.bundle) {
        $$('[data-tier]', this.bundle).forEach((tier) => {
          const q = parseInt(tier.dataset.qty, 10) || 1;
          const d = parseFloat(tier.dataset.discount) || 0;
          const units = tier.classList.contains('is-selected') ? t.units : Array(q).fill(v);
          const base = units.reduce((a, x) => a + x.price, 0);
          const cmp = units.reduce((a, x) => a + (x.compare_at_price > x.price ? x.compare_at_price : x.price), 0);
          const tot = Math.round((base * (100 - d)) / 100);
          const p = $('[data-tier-price]', tier);
          if (p) p.textContent = fmt(tot);
          const c = $('[data-tier-compare]', tier);
          if (c) { c.textContent = cmp > tot ? fmt(cmp) : ''; c.hidden = !(cmp > tot); }
          const each = $('[data-tier-each]', tier);
          if (each) each.textContent = `${fmt(Math.round(tot / q))} ${T.strings.each || ''}`;
        });
      }

      /* Stock status */
      const stock = $('[data-stock]', this.el);
      if (stock) {
        const threshold = parseInt(stock.dataset.threshold, 10) || 0;
        const low = v.available && v.inventory !== null && v.inventory !== undefined && v.inventory > 0 && v.inventory <= threshold;
        stock.classList.toggle('is-low', !!low);
        stock.hidden = !v.available;
        const txt = $('[data-stock-text]', stock);
        if (txt) txt.textContent = low ? stock.dataset.low.replace('[count]', v.inventory) : stock.dataset.ok;
      }

      /* Buttons */
      const label = t.available ? (T.strings.addToCart || 'Add to cart') : (T.strings.soldOut || 'Sold out');
      $$('[data-atc]', this.el).forEach((b) => {
        b.disabled = !t.available;
        const l = $('[data-atc-label]', b);
        if (l) l.textContent = t.available && this.showPriceInBtn ? `${label} — ${fmt(t.grand)}` : label;
      });
      const stickyBtn = $('[data-sticky-btn]', this.el);
      if (stickyBtn) { stickyBtn.disabled = !t.available; stickyBtn.textContent = label; }
      $$('[data-sticky-price]', this.el).forEach((n) => (n.textContent = fmt(t.grand)));
      if (this.idInput) this.idInput.value = v.id;
    }

    bindForm() {
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const t = this.totals();
        if (!t.available) return;
        const map = new Map();
        t.units.forEach((v) => map.set(v.id, (map.get(v.id) || 0) + 1));
        const items = Array.from(map, ([id, quantity]) => ({ id, quantity }));
        $$('[data-upsell]', this.el).forEach((u) => {
          const cb = $('[data-upsell-check]', u);
          if (cb && cb.checked) items.push({ id: parseInt(u.dataset.variantId, 10), quantity: 1 });
        });
        const btns = $$('[data-atc], [data-sticky-btn]', this.el);
        const err = $('[data-form-error]', this.el);
        if (err) err.hidden = true;
        btns.forEach((b) => b.classList.add('is-loading'));
        try {
          await Cart.add(items);
        } catch (error) {
          if (err) { err.textContent = error.message; err.hidden = false; } else toast(error.message);
        } finally {
          btns.forEach((b) => b.classList.remove('is-loading'));
        }
      });
    }

    bindSticky() {
      const bar = $('[data-sticky-atc]', this.el);
      const mainBtn = this.form && $('[data-atc]', this.form);
      if (!bar || !mainBtn) return;
      const stickyBtn = $('[data-sticky-btn]', bar);
      stickyBtn && stickyBtn.addEventListener('click', () => {
        if (this.form.requestSubmit) this.form.requestSubmit();
        else mainBtn.click();
      });
      if (!('IntersectionObserver' in window)) return;
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
      }).observe(mainBtn);
    }
  }

  function initProducts(scope) {
    $$('[data-product-section]', scope).forEach((el) => {
      if (el._product) return;
      el._product = new Product(el);
    });
  }

  /* ---------------- Init ---------------- */
  function initAll(scope = document) {
    initAnnouncements(scope);
    initProducts(scope);
    initShipBars(scope);
    initCountdowns(scope);
    initDelivery(scope);
    initReveal(scope);
    initCounters(scope);
    initRecommendations(scope);
  }

  const boot = () => { initAll(document); onScroll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-announcement-slide]');
    if (slide) {
      $$('[data-announcement-slide]', slide.parentElement).forEach((s) => s.classList.toggle('is-active', s === slide));
    }
  });
})();
